import React from 'react';
import { Text, View } from 'react-native';
import { IconButton } from 'react-native-paper';

import { IMessage } from '@common/hooks/useGptConversation';
import { useGptConversationContext } from '../../../GptConversation/context';
import { MessageContent } from './MessageContent';
import createStyles from './style';

const Message = ({
  message,
  senderType,
  hideAvatar,
}: {
  message: IMessage;
  senderType: IMessage['senderType'];
  hideAvatar?: boolean;
}) => {
  const { props, getSenderName } = useGptConversationContext();
  const styles = createStyles({ ...props, senderType });
  const { attributes } = props;

  return (
    <View
      style={[
        styles.container,
        hideAvatar ? { marginBottom: 16 } : { marginBottom: 8 },
      ]}
    >
      {hideAvatar ? (
        <View style={styles.avatarBox}></View>
      ) : (
        <IconButton
          icon={
            senderType === 'user'
              ? attributes.user?.icon
              : attributes.chatbot?.icon
          }
          color={
            senderType === 'user'
              ? (attributes.user?.styles?.iconColor || attributes.user?.iconColor)
              : (attributes.chatbot?.styles?.iconColor || attributes.chatbot?.iconColor)
          }
          size={20}
          style={[styles.chatIcon, styles.avatarBox]}
        />
      )}
      <View
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          marginHorizontal: 8,
        }}
      >
        <Text
          style={[styles.senderName, hideAvatar ? { display: 'none' } : {}]}
        >
          {getSenderName(message.senderType)}
        </Text>
        <View style={styles.textWrapper}>
          <MessageContent message={message} styles={styles} />
        </View>
      </View>
      <View style={{ width: 36 }}></View>
    </View>
  );
};

export default Message;
